var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakeADonation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119.771,
    height: 119.779,
    viewBox: "0 0 119.771 119.779",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7233",
    "data-name": "Rectangle 7233",
    width: 119.771,
    height: 119.779,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68423",
    "data-name": "Group 68423",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68422",
    "data-name": "Group 68422",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44500",
    "data-name": "Path 44500",
    d: "M74.358,7.187A19.53,19.53,0,0,0,49.046,5.216,19.527,19.527,0,0,0,23.731,34.8L44.565,55.634a6.332,6.332,0,0,0,8.955,0L74.354,34.8a19.528,19.528,0,0,0,0-27.613",
    transform: "translate(10.834 0.878)",
    fill: "#e01f27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44501",
    "data-name": "Path 44501",
    d: "M11.267,55.6l15.226-9.984a25.613,25.613,0,0,1,23.363-2.439l18.47,7.218a6.371,6.371,0,0,1-2.318,12.313H67.39A30.7,30.7,0,0,0,89.1,53.718L100.08,42.735a6.181,6.181,0,0,1,8.741,8.741L95.337,64.96a36.912,36.912,0,0,1-26.1,10.814h-37.8Z",
    transform: "translate(6.78 24.628)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44502",
    "data-name": "Path 44502",
    d: "M28.848,87.311,2.8,61.263a4.572,4.572,0,0,1,0-6.466L8.43,49.165a4.572,4.572,0,0,1,6.466,0L40.944,75.213a4.57,4.57,0,0,1,0,6.465v0l-5.632,5.632a4.572,4.572,0,0,1-6.466,0Z",
    transform: "translate(0.878 28.78)",
    fill: "#00a2d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44503",
    "data-name": "Path 44503",
    d: "M117.264,41.959a8.52,8.52,0,0,0-12.049,0L94.232,52.943a28.176,28.176,0,0,1-13.344,7.511,8.708,8.708,0,0,0-4.833-11.328l-.082-.032L57.5,41.876A28,28,0,0,0,32,44.537L18.364,53.489l-.937-.937a6.92,6.92,0,0,0-9.774,0L2.022,58.184a6.917,6.917,0,0,0,0,9.774L28.07,94.006a6.909,6.909,0,0,0,9.772,0l0,0,5.632-5.632A6.909,6.909,0,0,0,43.841,79h32.2A38.989,38.989,0,0,0,103.792,67.5l13.484-13.484a8.52,8.52,0,0,0,0-12.049h0Zm-77.1,43.1-5.632,5.632a2.23,2.23,0,0,1-3.157,0L5.331,64.64a2.234,2.234,0,0,1,0-3.155l5.638-5.633a2.235,2.235,0,0,1,3.159,0L40.176,81.9a2.233,2.233,0,0,1,0,3.157ZM113.956,50.7,100.473,64.184A34.34,34.34,0,0,1,76.03,74.309H39.2L21.743,56.857l12.822-8.409A23.311,23.311,0,0,1,55.8,46.235l18.468,7.218a4.037,4.037,0,0,1-1.469,7.8H50.552a2.339,2.339,0,0,0,0,4.679H74.18a32.828,32.828,0,0,0,23.365-9.675l10.982-10.983a3.843,3.843,0,0,1,5.512,5.356c-.026.026-.051.051-.078.077Z",
    transform: "translate(0 23.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44504",
    "data-name": "Path 44504",
    d: "M40.787,35.234a4.056,4.056,0,0,1-4.331-3.715,2.339,2.339,0,1,0-4.679,0,8.532,8.532,0,0,0,6.67,8.11v.812a2.339,2.339,0,1,0,4.679,0v-.825a8.526,8.526,0,0,0,6.668-8.11,8.727,8.727,0,0,0-9.008-8.392A3.757,3.757,0,1,1,45.117,19.4a2.339,2.339,0,1,0,4.677,0,8.529,8.529,0,0,0-6.668-8.11v-.812a2.339,2.339,0,1,0-4.679,0v.812a8.532,8.532,0,0,0-6.67,8.11,8.728,8.728,0,0,0,9.01,8.392,3.758,3.758,0,1,1,0,7.429Z",
    transform: "translate(19.122 4.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44505",
    "data-name": "Path 44505",
    d: "M43.793,58.167a8.672,8.672,0,0,0,12.263,0l0,0L76.892,37.333A21.867,21.867,0,0,0,49.928,3.274,21.819,21.819,0,0,0,33.233.628,2.339,2.339,0,0,0,34.34,5.174,17.152,17.152,0,0,1,48.547,7.982a2.341,2.341,0,0,0,2.761,0A17.184,17.184,0,0,1,73.586,34.025L52.752,54.859a3.992,3.992,0,0,1-5.646,0l0,0L26.27,34.025a17.08,17.08,0,0,1-4.544-16.237,2.339,2.339,0,0,0-4.546-1.105,21.728,21.728,0,0,0,5.782,20.66Z",
    transform: "translate(9.953 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44506",
    "data-name": "Path 44506",
    d: "M22.46,8.253a2.341,2.341,0,1,0-1.653-.686,2.339,2.339,0,0,0,1.653.686",
    transform: "translate(12.108 2.15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeADonation);
export default __webpack_public_path__ + "static/media/make_a_donation.0944cb2033c7c8efe51f73438a285747.svg";
export { ForwardRef as ReactComponent };